import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { hasSomePermission } from "@/modules/auth/lib/permissions";

export const Route = createFileRoute("/__authed/m/materials")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (
			!hasSomePermission(user, ["see_materials", "see_material_requests", "see_materials_reseller"])
		) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: Outlet,
});
